import PostCheckout from "../components/site/PostCheckout";

// /pedido-cancelado — pago no completado; el pedido sigue guardado.
export default function PedidoCanceladoPage() {
  return (
    <PostCheckout
      eyebrow="Pago cancelado"
      title="No se completó el pago"
      body="No te preocupes, tu pedido sigue guardado. Puedes volver a WhatsApp y pedir el link de pago de nuevo cuando quieras."
      pageTitle="Pago no completado — SoyPacoIA"
    />
  );
}
